<template>
    <Teleport to="body">
        <div v-if="aberto" class="tw-fixed tw-inset-0 tw-z-[2000]" :class="recorte ? 'tw-pointer-events-none' : ''" role="dialog" aria-modal="true" :aria-label="passo.titulo">
            <div v-if="!recorte" class="tw-absolute tw-inset-0 tw-bg-black/70 tutorial-fade"></div>
            <template v-else>
                <div class="tw-absolute tutorial-recorte" :class="{ 'tutorial-recorte--seguindo': seguindo }" :style="recorteEstilo">
                    <span class="tw-absolute tw-inset-0 tw-rounded-2xl tw-ring-2 tw-ring-green-400 tutorial-pulso"></span>
                </div>
                <div v-for="(b, i) in bloqueadores" :key="'b' + i" class="tw-absolute tw-pointer-events-auto" :style="b"></div>
            </template>

            <div v-if="!passo.alvo" class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-p-4">
                <div :key="indice" :class="cartao" class="tw-w-full tw-max-w-lg tw-p-6 md:tw-p-8 tutorial-entrada">
                    <div class="tw-flex tw-items-center tw-gap-3">
                        <span class="tw-w-12 tw-h-12 tw-rounded-2xl tw-bg-green-500/15 tw-text-green-400 tw-flex tw-items-center tw-justify-center tutorial-brilho">
                            <svg class="tw-w-6 tw-h-6" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.6 6.4L21 11l-6.4 2.6L12 20l-2.6-6.4L3 11l6.4-2.6z"/></svg>
                        </span>
                        <span class="tw-text-xs tw-font-bold tw-tracking-[0.12em] tw-text-green-400">WINCKIEEL IA</span>
                    </div>
                    <h2 class="tw-text-2xl md:tw-text-3xl tw-font-black tw-leading-tight tw-mt-4">{{ passo.titulo }}</h2>
                    <p class="tw-text-sm md:tw-text-base tw-leading-relaxed tw-mt-2" :class="soft">{{ passo.texto }}</p>
                    <ul v-if="passo.itens" class="tw-mt-5 tw-space-y-3">
                        <li v-for="(item, i) in passo.itens" :key="item.texto" class="tw-flex tw-gap-3 tw-items-start tutorial-item" :style="{ animationDelay: `${150 + i * 140}ms` }">
                            <span class="tw-w-9 tw-h-9 tw-rounded-xl tw-flex tw-items-center tw-justify-center tw-flex-shrink-0" :class="[item.cor, dark ? 'tw-bg-white/5' : 'tw-bg-gray-100']">
                                <svg class="tw-w-[18px] tw-h-[18px]" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path :d="item.icone"/></svg>
                            </span>
                            <span class="tw-text-sm tw-leading-snug tw-pt-2">{{ item.texto }}</span>
                        </li>
                    </ul>
                    <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mt-7">
                        <button v-if="indice === 0" type="button" @click="fechar" class="tw-text-sm tw-font-medium tw-px-3 tw-min-h-[44px]" :class="muted">Agora não</button>
                        <button v-else type="button" @click="voltar" class="tw-text-sm tw-font-medium tw-px-3 tw-min-h-[44px]" :class="muted">Voltar</button>
                        <button type="button" ref="botaoPrincipal" @click="avancar" class="tw-inline-flex tw-items-center tw-gap-2 tw-min-h-[44px] tw-px-5 tw-rounded-xl tw-bg-green-600 hover:tw-bg-green-500 tw-text-white tw-text-sm tw-font-bold">
                            {{ ultimo ? 'Começar' : 'Ver como funciona' }}
                            <svg v-if="!ultimo" class="tw-w-4 tw-h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>
                        </button>
                    </div>
                </div>
            </div>

            <div v-else-if="recorte" :key="indice" :class="cartao" class="tw-absolute tw-p-5 tw-pointer-events-auto tutorial-entrada" :style="balaoEstilo">
                <p class="tw-text-[11px] tw-font-bold tw-tracking-[0.12em] tw-text-green-400">PASSO {{ numeroPasso }} DE {{ totalPassos }}</p>
                <h3 class="tw-text-lg tw-font-bold tw-mt-1">{{ passo.titulo }}</h3>
                <p class="tw-text-sm tw-leading-relaxed tw-mt-1.5" :class="soft">{{ passo.texto }}</p>
                <div class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-mt-4">
                    <div class="tw-flex tw-gap-1.5" aria-hidden="true">
                        <span v-for="n in totalPassos" :key="n" class="tw-h-1.5 tw-rounded-full tw-transition-all" :class="n === numeroPasso ? 'tw-w-5 tw-bg-green-500' : ['tw-w-1.5', dark ? 'tw-bg-white/20' : 'tw-bg-gray-300']"></span>
                    </div>
                    <div class="tw-flex tw-items-center tw-gap-1">
                        <button type="button" @click="fechar" class="tw-text-xs tw-font-medium tw-px-2 tw-min-h-[40px]" :class="muted">Pular</button>
                        <button type="button" @click="voltar" class="tw-text-sm tw-font-medium tw-px-3 tw-min-h-[40px] tw-rounded-lg" :class="dark ? 'hover:tw-bg-white/5' : 'hover:tw-bg-gray-100'">Voltar</button>
                        <button type="button" ref="botaoPrincipal" @click="avancar" class="tw-min-h-[40px] tw-px-4 tw-rounded-lg tw-bg-green-600 hover:tw-bg-green-500 tw-text-white tw-text-sm tw-font-bold">Próximo</button>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script>
const PASSOS = [
    {
        titulo: 'Conheça a Winckieel IA',
        texto: 'Um assistente agronômico que lê o seu silo e diz, em poucos segundos, como está o grão e o que fazer.',
        itens: [
            { texto: 'Lê a temperatura de cada sensor e encontra pontos aquecendo', cor: 'tw-text-red-400', icone: 'M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z' },
            { texto: 'Compara com a leitura de 7 dias atrás para mostrar a tendência', cor: 'tw-text-yellow-400', icone: 'M3 17l6-6 4 4 8-8M15 7h6v6' },
            { texto: 'Cruza com o clima da estação e o programa de aeração do silo', cor: 'tw-text-blue-400', icone: 'M17.5 19a4.5 4.5 0 1 0-1.4-8.8A6 6 0 0 0 4.3 12 4 4 0 0 0 6 19z' },
            { texto: 'Entrega um plano de ação e as faixas ideais de aeração', cor: 'tw-text-green-400', icone: 'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11' },
        ],
    },
    { alvo: 'silo', titulo: 'Escolha o silo', texto: 'Clique no silo que deseja analisar: você já pode ir preenchendo enquanto acompanha. A cor de cada cartão mostra o resultado da última análise.' },
    { alvo: 'objetivo', titulo: 'Defina o objetivo', texto: 'Secagem, conservação ou resfriamento. As recomendações de aeração mudam conforme o objetivo.' },
    { alvo: 'umidade', titulo: 'Informe a umidade do grão', texto: 'É opcional, mas deixa a análise mais precisa: sem ela, os riscos de fungos e de reumedecimento não são avaliados.' },
    { alvo: 'gerar', titulo: 'Gere a análise', texto: 'Confira o resumo e clique em “Gerar análise”. Em alguns segundos o relatório fica pronto, com diagnóstico, riscos e plano de aeração.' },
    { alvo: 'historico', titulo: 'Consulte o histórico', texto: 'Todas as análises ficam salvas aqui, separadas por silo. Clique em uma para abrir o relatório de novo.' },
    { titulo: 'Tudo pronto!', texto: 'Escolha um silo e gere a sua primeira análise. Você pode rever este passo a passo quando quiser em “Como funciona”.' },
];

const MARGEM = 8;
const GUTTER = 16;

export default {
    name: 'TutorialWinckieelIA',
    props: {
        aberto: { type: Boolean, default: false },
        theme: { type: String, default: 'dark' },
    },
    emits: ['fechar'],
    data() {
        return { indice: 0, recorte: null, seguindo: false, larguraTela: window.innerWidth, alturaTela: window.innerHeight };
    },
    computed: {
        dark() { return this.theme === 'dark'; },
        cartao() {
            return this.dark
                ? 'tw-bg-[#1a1d21] tw-text-gray-100 tw-rounded-2xl tw-shadow-2xl tw-ring-1 tw-ring-white/10'
                : 'tw-bg-white tw-text-gray-800 tw-rounded-2xl tw-shadow-2xl tw-ring-1 tw-ring-black/5';
        },
        muted() { return this.dark ? 'tw-text-gray-400 hover:tw-text-gray-200' : 'tw-text-gray-500 hover:tw-text-gray-800'; },
        soft() { return this.dark ? 'tw-text-gray-300' : 'tw-text-gray-600'; },
        passos() { return PASSOS; },
        passo() { return PASSOS[this.indice]; },
        ultimo() { return this.indice === PASSOS.length - 1; },
        passosComAlvo() { return PASSOS.map((p, i) => (p.alvo ? i : null)).filter(i => i !== null); },
        totalPassos() { return this.passosComAlvo.length; },
        numeroPasso() { return this.passosComAlvo.indexOf(this.indice) + 1; },
        recorteEstilo() {
            const r = this.recorte;
            return {
                top: `${r.top}px`, left: `${r.left}px`, width: `${r.width}px`, height: `${r.height}px`,
                borderRadius: '16px',
                boxShadow: '0 0 0 9999px rgba(3, 7, 18, 0.72)',
            };
        },
        bloqueadores() {
            const r = this.recorte;
            if (!r) return [];
            const px = v => `${Math.max(0, v)}px`;
            return [
                { top: 0, left: 0, right: 0, height: px(r.top) },
                { top: px(r.top + r.height), left: 0, right: 0, bottom: 0 },
                { top: px(r.top), left: 0, width: px(r.left), height: px(r.height) },
                { top: px(r.top), left: px(r.left + r.width), right: 0, height: px(r.height) },
            ];
        },
        balaoEstilo() {
            const r = this.recorte;
            const largura = Math.min(380, this.larguraTela - 2 * GUTTER);
            const alturaEstimada = 200;
            const espacoAbaixo = this.alturaTela - (r.top + r.height);
            const abaixo = espacoAbaixo >= alturaEstimada + GUTTER || espacoAbaixo >= r.top;
            let left = r.left + r.width / 2 - largura / 2;
            left = Math.max(GUTTER, Math.min(left, this.larguraTela - largura - GUTTER));
            const estilo = { width: `${largura}px`, left: `${left}px` };
            if (abaixo) estilo.top = `${Math.min(r.top + r.height + 12, this.alturaTela - alturaEstimada - GUTTER)}px`;
            else estilo.bottom = `${Math.min(this.alturaTela - r.top + 12, this.alturaTela - alturaEstimada - GUTTER)}px`;
            return estilo;
        },
    },
    watch: {
        aberto(valor) {
            if (valor) {
                this.indice = 0;
                this.irPara(0);
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.aoMudarTela);
        window.addEventListener('scroll', this.aoMudarTela, true);
        window.addEventListener('keydown', this.aoTeclar);
        if (this.aberto) this.irPara(0);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.aoMudarTela);
        window.removeEventListener('scroll', this.aoMudarTela, true);
        window.removeEventListener('keydown', this.aoTeclar);
        cancelAnimationFrame(this.quadro);
        clearTimeout(this.timerRolagem);
        clearTimeout(this.timerSeguindo);
        if (this.observador) this.observador.disconnect();
    },
    methods: {
        elementoDoPasso(i) {
            const p = PASSOS[i];
            if (!p || !p.alvo) return null;
            const el = document.querySelector(`[data-tour="${p.alvo}"]`);
            if (!el) return null;
            const r = el.getBoundingClientRect();
            if (r.width === 0 || r.height === 0 || r.right <= 0 || r.left >= window.innerWidth) return null;
            return el;
        },
        irPara(i) {
            let alvo = i;
            const direcao = i >= this.indice ? 1 : -1;
            while (PASSOS[alvo] && PASSOS[alvo].alvo && !this.elementoDoPasso(alvo)) alvo += direcao;
            if (alvo < 0) alvo = 0;
            if (alvo >= PASSOS.length) alvo = PASSOS.length - 1;
            this.indice = alvo;
            const el = this.elementoDoPasso(alvo);
            this.observar(el);
            if (!el) {
                this.recorte = null;
                this.focar();
                return;
            }
            this.rolarAte(el);
            this.focar();
        },
        focar() {
            this.$nextTick(() => this.$refs.botaoPrincipal && this.$refs.botaoPrincipal.focus({ preventScroll: true }));
        },
        containerRolagem(el) {
            let p = el.parentElement;
            while (p && p !== document.body) {
                const oy = getComputedStyle(p).overflowY;
                if ((oy === 'auto' || oy === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
                p = p.parentElement;
            }
            return document.scrollingElement || document.documentElement;
        },
        // Rola até deixar o alvo visível com espaço para o balão abaixo. O recorte vai
        // direto para a posição final (calculada) em vez de seguir a rolagem suave.
        rolarAte(el) {
            clearTimeout(this.timerRolagem);
            this.larguraTela = window.innerWidth;
            this.alturaTela = window.innerHeight;
            const cont = this.containerRolagem(el);
            const ehDocumento = cont === document.scrollingElement || cont === document.documentElement;
            const topoArea = ehDocumento ? 0 : cont.getBoundingClientRect().top;
            const alturaArea = ehDocumento ? window.innerHeight : cont.clientHeight;
            const r = el.getBoundingClientRect();
            const espacoBalao = 230;
            const desejado = r.height + 2 * MARGEM + espacoBalao <= alturaArea
                ? Math.max(GUTTER * 2, (alturaArea - espacoBalao - r.height) / 2)
                : 80;
            const atual = cont.scrollTop;
            const maximo = cont.scrollHeight - cont.clientHeight;
            const destino = Math.min(maximo, Math.max(0, atual + (r.top - topoArea) - desejado));
            const delta = destino - atual;

            this.travado = Math.abs(delta) > 1;
            this.recorte = this.recorteDe({ top: r.top - delta, left: r.left, width: r.width, height: r.height });
            if (!this.travado) return;

            const alvoEventos = ehDocumento ? window : cont;
            const terminar = () => {
                alvoEventos.removeEventListener('scrollend', terminar);
                clearTimeout(this.timerRolagem);
                this.travado = false;
                this.seguirSemAnimacao();
            };
            alvoEventos.addEventListener('scrollend', terminar, { once: true });
            this.timerRolagem = setTimeout(terminar, 800);
            cont.scrollTo({ top: destino, behavior: 'smooth' });
        },
        recorteDe(r) {
            return {
                top: Math.max(GUTTER / 2, r.top - MARGEM),
                left: Math.max(GUTTER / 2, r.left - MARGEM),
                width: Math.min(r.width + 2 * MARGEM, window.innerWidth - GUTTER),
                height: Math.min(r.height + 2 * MARGEM, window.innerHeight - GUTTER),
            };
        },
        seguirSemAnimacao() {
            this.seguindo = true;
            this.medir();
            clearTimeout(this.timerSeguindo);
            this.timerSeguindo = setTimeout(() => { this.seguindo = false; }, 150);
        },
        // Reage a mudanças de tamanho do alvo (ex.: cartão selecionado, campo preenchido)
        observar(el) {
            if (this.observador) this.observador.disconnect();
            if (!el || typeof ResizeObserver === 'undefined') return;
            this.observador = new ResizeObserver(() => this.aoMudarTela());
            this.observador.observe(el);
        },
        medir() {
            this.larguraTela = window.innerWidth;
            this.alturaTela = window.innerHeight;
            const el = this.elementoDoPasso(this.indice);
            if (!el) {
                this.recorte = null;
                return;
            }
            this.recorte = this.recorteDe(el.getBoundingClientRect());
        },
        aoMudarTela() {
            if (!this.aberto || this.travado) return;
            cancelAnimationFrame(this.quadro);
            this.quadro = requestAnimationFrame(this.seguirSemAnimacao);
        },
        aoTeclar(e) {
            if (!this.aberto) return;
            const t = e.target;
            const digitando = t && (['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName) || t.isContentEditable);
            if (e.key === 'Escape') this.fechar();
            else if (digitando) return;
            else if (e.key === 'ArrowRight') this.avancar();
            else if (e.key === 'ArrowLeft') this.voltar();
        },
        avancar() {
            if (this.ultimo) this.fechar();
            else this.irPara(this.indice + 1);
        },
        voltar() {
            if (this.indice > 0) this.irPara(this.indice - 1);
        },
        fechar() {
            this.$emit('fechar');
        },
    },
};
</script>

<style scoped>
.tutorial-recorte {
    transition: top 0.35s ease, left 0.35s ease, width 0.35s ease, height 0.35s ease;
    pointer-events: none;
}
.tutorial-recorte--seguindo {
    transition: none;
}
.tutorial-pulso {
    animation: tutorial-pulso 1.6s ease-out infinite;
}
.tutorial-fade {
    animation: tutorial-fade 0.25s ease-out both;
}
.tutorial-entrada {
    animation: tutorial-entrada 0.3s ease-out both;
}
.tutorial-item {
    animation: tutorial-entrada 0.4s ease-out both;
}
.tutorial-brilho {
    animation: tutorial-brilho 2.4s ease-in-out infinite;
}
@keyframes tutorial-pulso {
    0% { box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.55); }
    100% { box-shadow: 0 0 0 14px rgba(74, 222, 128, 0); }
}
@keyframes tutorial-fade {
    from { opacity: 0; }
    to { opacity: 1; }
}
@keyframes tutorial-entrada {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}
@keyframes tutorial-brilho {
    0%, 100% { box-shadow: 0 0 0 0 rgba(34, 197, 94, 0); }
    50% { box-shadow: 0 0 24px 2px rgba(34, 197, 94, 0.35); }
}
@media (prefers-reduced-motion: reduce) {
    .tutorial-recorte, .tutorial-pulso, .tutorial-fade, .tutorial-entrada, .tutorial-item, .tutorial-brilho {
        animation: none;
        transition: none;
    }
}
</style>
